import { Component, Input, OnInit, AfterViewInit} from "@angular/core";
import { FormGroup } from "@angular/forms";

import {InsaCronService} from "../../../../../insa-services";
import { SMSJobDetails } from "../../../../../insa-models";

@Component({
    selector: "edit-sms-activity-details",
    template: require("./edit-sms-activity-details.component.html")
})


export class EditSMSAcitivityDetailsComponent implements OnInit{
    
    _activityID: any;
    
    @Input() editSMSForm: FormGroup;
    @Input() set smsDetails(smsData: any){this._activityID = smsData;}

    smsData: SMSJobDetails = new SMSJobDetails(); //holi

    constructor(private _insaChronosService: InsaCronService){  }

    ngOnInit(){
        if(this._activityID !== null && this._activityID !== null){
            this._insaChronosService.getSMSDetailsById(this._activityID).subscribe((p: any) => this.smsData = p)
        }
    }

    // ngAfterViewInit(){
    //     if(this._activityID !== null && this._activityID !== null){
    //         this._insaChronosService.getSMSDetailsById(this._activityID).subscribe(p => this.smsData = p)
    //     }
    // }
}





// WEBPACK FOOTER //
// ./app/insa-components/insa-cron/insa-job/insa-activities-detail/sms-activity-details/edit-sms-activity-details.component.ts